<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2555_932)">
      <path d="M9.104 7.99995L15.7728 1.33435C16.0768 1.03035 16.0768 0.534349 15.7728 0.230349C15.4688 -0.0736507 14.9728 -0.0736507 14.6688 0.230349L8.0032 6.89595L1.3344 0.227149C1.0304 -0.0768507 0.5344 -0.0768507 0.2304 0.227149C-0.0768 0.534349 -0.0768 1.02715 0.2304 1.33435L6.896 7.99995L0.2304 14.6655C0.00639999 14.8895 -0.0608 15.2255 0.0608 15.5167C0.1824 15.8079 0.4672 15.9999 0.784 15.9999C0.992 15.9999 1.1904 15.9167 1.3376 15.7727L8.0032 9.10715L14.6688 15.7727C14.816 15.9199 15.0144 16.0031 15.2224 15.9999C15.5392 15.9999 15.824 15.8111 15.9456 15.5167C16.0672 15.2255 16 14.8895 15.776 14.6655L9.1104 7.99995H9.104Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_2555_932">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>